
    if (import.meta.env.MODE === 'production') {
      // Google Optimize
      const optimizeScript = document.createElement('script')
      optimizeScript.src = 'https://www.googleoptimize.com/optimize.js?id=OPT-WZ7MN2M'
      document.head.appendChild(optimizeScript)

      // Facebook Pixel
      !function (f,b,e,v,n,t,s) {
        if (f.fbq) return;n=f.fbq=function () {
          n.callMethod ?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)
        };
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');

      // Dub Analytics — GDPR/KVKV uyumluluğu için
      window.dubConfig = {
        respectDoNotTrack: true,
        enableCookies: true
      }

      // Dub ID parameter & cookie handler
      const urlParams = new URLSearchParams(window.location.search)
      const dubId = urlParams.get('dub_id')
      if (dubId) {
        const expiryDate = new Date()
        expiryDate.setDate(expiryDate.getDate() + 30)
        document.cookie = `dub_id=${dubId}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`
        window.dubConfig.dubId = dubId
      } else {
        const cookies = document.cookie.split(';')
        for (let cookie of cookies) {
          const [name, value] = cookie.trim().split('=')
          if (name === 'dub_id') {
            window.dubConfig.dubId = value
            break
          }
        }
      }

      const dubScript = document.createElement('script')
      dubScript.defer = true
      dubScript.src = 'https://www.dubcdn.com/analytics/script.js'
      dubScript.setAttribute('data-website-id', 'YOUR_WEBSITE_ID')
      dubScript.setAttribute('data-respect-dnt', 'true')
      dubScript.setAttribute('data-enable-cookies', 'false')
      document.head.appendChild(dubScript)
    }
  